export default __webpack_public_path__ + "static/media/news.b0462d1a.gif";